import React, { useMemo, useState } from 'react';
import moment from 'moment';
import Toast from 'react-native-root-toast';
import { useNavigation } from '@react-navigation/native';

import { CREATE_STOCKTAKE } from '../../../common/graphql/stocktake';
import { useUserContext } from '../../../common/utils/context';
import { formatDate } from '../../../common/utils/utils';

import { ActionDock, Screen } from '../../design/components';

import StocktakeCreator from './StocktakeCreator';

const StocktakeCreatorView = () => {
	const navigation = useNavigation();
	const { user } = useUserContext();
	// The child reports its primary action so it renders in the measured Screen dock.
	const [dockProps, setDockProps] = useState(null);

	const initialValues = useMemo(() => ({
		date: new Date().toISOString(),
		description: '',
		user: user || null,
		warehouse: null,
	}), [user]);

	const handleSuccess = (newStocktake) => {
		if (newStocktake?.id) {
			Toast.show('Stocktake created');
			navigation.replace('StocktakeDetailView', { id: newStocktake.id });
		}
	};

	return (
		<Screen
			backLabel="Stocktakes"
			heading="New stocktake"
			subheading={formatDate(moment(), 'DAY_MONTHWORD_YEAR')}
			scroll={false}
			dock={dockProps ? <ActionDock hint={dockProps.hint} action={dockProps.action} /> : null}
		>
			<StocktakeCreator
				createMutation={CREATE_STOCKTAKE}
				initialValues={initialValues}
				onSubmitSuccess={handleSuccess}
				onDockChange={setDockProps}
			/>
		</Screen>
	);
};

export default StocktakeCreatorView;
